import React from 'react'

const VerifyPage = React.lazy(() => import('pages/account/Verify'))
const Home = React.lazy(() => import('pages/Home'))

const routesList = [
  {
    path: '/verify/:token',
    name: 'E-Mail Verification',
    description: 'E-Mail Id Verification',
    component: <VerifyPage />,
    exact: true,
    checkLogin: false
  },
  {
    path: '/',
    name: 'InnoSales - Create, Share & Grow',
    description:
      'Create a Professional-looking product catalogue and showcase your product digitally using a customizable template in just 3 simple clicks',
    component: <Home />,
    exact: true,
    checkLogin: false
  }
]

export default routesList
